import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';

class ScrollItem__HAHA extends Scroll_Item {
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._svgs = GetBy.selector('svg', __link);
    gsap.set(this._svgs, { opacity: 0, scale: 2.2 });

    this.onShow = () => {
      gsap.to(this._svgs, { opacity: 1, delay: 0.4, stagger: 0.1, duration: .1 });
      gsap.to(this._svgs, { scale: 1, delay: 0.5, stagger: 0.1, duration: .08 });
    };
    this.onHide = () => { };
    this.onMove = () => { };
  }

  resize(__w, __h) {
    super.resize(__w, __h);
  }
}

Scroll._registerClass('HAHA', ScrollItem__HAHA);

export default ScrollItem__HAHA;
